import React from "react";
import ServiceDetail from "./ServiceDetail";
import WebDesignBanner from "../../Components/Assets/Web-Design-Banner.jpeg";

function WebDesign() {
  return (
    <ServiceDetail
      eyebrow="Website Design"
      title="Website Design Packages"
      description="Modern, responsive website packages built to help your business look professional, generate leads, and convert visitors into customers."
      ctaText="Request Website Quote"

      heroImage={WebDesignBanner}

      packages={[
        {
          name: "Starter Website",
          subtitle: "Best for simple online presence",
          price: 1200,
          features: [
            "1–2 custom pages",
            "Mobile responsive design",
            "Contact form setup",
            "Basic SEO structure",
            "Social media links",
            "Website hand-off",
          ],
        },
        {
          name: "Business Website",
          subtitle: "Best for growing businesses",
          price: 2500,
          featured: true,
          features: [
            "3–4 custom pages",
            "Mobile responsive design",
            "Contact form and lead capture",
            "Basic on-page SEO",
            "Google Maps integration",
            "30 days basic support",
          ],
        },
        {
          name: "Premium Website",
          subtitle: "Complete professional website",
          price: 5000,
          features: [
            "5–6 custom pages",
            "Advanced responsive design",
            "SEO-ready page structure",
            "Blog or portfolio setup",
            "Speed optimization",
            "Website maintenance support",
          ],
        },
      ]}
      process={[
        {
          title: "Plan",
          text: "We review your goals, pages, content, and the kind of customers you want to attract.",
        },
        {
          title: "Design",
          text: "Your website is designed with a clean layout, strong branding, and mobile-friendly structure.",
        },
        {
          title: "Launch",
          text: "We finalize the site, test it across devices, and prepare it for launch.",
        },
      ]}
    />
  );
}

export default WebDesign;